/** "Farjana Sadi" -> "FS". */
export const initials = (name?: string) =>
  (name || "")
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0]?.toUpperCase())
    .join("") || "U";

/** COMPANY_ADMIN -> "Company Admin"; short keys are acronyms and stay as they are (HR, IT). */
export const roleKeyLabel = (key?: string) =>
  (key || "")
    .split("_")
    .filter(Boolean)
    .map((w) => (w.length <= 3 ? w.toUpperCase() : w[0].toUpperCase() + w.slice(1).toLowerCase()))
    .join(" ");
